import { render, staticRenderFns } from "./SolInternas.vue?vue&type=template&id=16289437&scoped=true&"
import script from "./SolInternas.vue?vue&type=script&lang=js&"
export * from "./SolInternas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16289437",
  null
  
)

export default component.exports